/*
 * @Author: ailin
 * @Date: 2022-07-12 11:34:58
 * @LastEditors: DT
 * @LastEditTime: 2022-12-14 10:31:55
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/me/userCenter/userCenter.js
 */
import {
  getOrderNumByStatus,
  getUserBaseInfo,
  personalCenterInfoApi,
} from "@/libs/api";
import store from "@/store";
import { types } from "@/store/user";
export default {
  name: "userCenter",
  data() {
    return {
      userInfo: {},
      orderObj: {
        toPay: 0,
        toTake: 0,
        toSigned: 0,
      },
      avatar: require("../../../assets/img/default-avatar.gif"),
      icon: {
        active: "https://img.yzcdn.cn/vant/user-active.png",
        inactive: "https://img.yzcdn.cn/vant/user-inactive.png",
      },
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      isLogin: false,
      accountBalance: "0.00", // 账户余额
      encouragement: "0.00", // 鼓励金总额
      uleCardBalance: "0.00", // 邮乐卡余额
      useableCouponCount: 0, // 可用优惠券数量
    };
  },
  filters: {
    formatNum: function(value) {
      if (value == "0") return "";
    },
  },
  created() {
    this.isLogin =
      this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")
        ? true
        : false;
    if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
      this.getUserInfo();
      this.getOrderNum();
      this.getPersonalCenterInfo();
    } else {
      console.log("未登录");
    }
  },
  methods: {
    getUserInfo() {
      getUserBaseInfo({}, "jsonCallback").then((res) => {
        this.userInfo = res.data;
        this.avatar = res.data.img;
      });
    },
    getOrderNum() {
      let data = {};
      getOrderNumByStatus(data, "jsonCallback").then((res) => {
        this.orderObj = res.data;
        // console.log(this.orderObj);
      });
    },
    toReturn() {
      window.location.href = `https://www.${this.$uleUrl()}/ule/h5/refund/index.html`;
    },
    toYTH() {
      window.location.href = `https://www.${this.$uleUrl()}/event/2019/tehui/member.html?adid=Internal_app_hyzx`;
    },
    handleToLogin() {
      this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先登录",
        })
        .then(() => {
          if (this.$browser().miniprogram) {
            window.wx.miniProgram.navigateTo({
              url:
                "/pages/authorize?target=" +
                encodeURIComponent(this.targetUrl) +
                "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
            });
          } else {
            window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
              this.targetUrl
            )}`;
          }
        })
        .catch(() => {});
    },
    // 退出登录
    logout() {
      console.log(this.$route.query);
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "请稍后...",
      });
      document.cookie = `mall_cookie=;domain=.${this.$uleUrl()};path=/;expires=3600`;
      document.cookie = `ul_utk=;domain=.${this.$uleUrl()};path=/;expires=3600`;
      store.commit(types.STORE_ID, "");
      localStorage.removeItem("isNewCustomer"); //清除用户是否新人标识
      localStorage.removeItem('popDay');
      localStorage.removeItem('popDayParam');
      localStorage.removeItem('popActivityParam');

      setTimeout(() => {
        this.$toast.clear();
        this.toNext("/", this.$route.query);
      }, 1000);
    },
    // 金额信息
    getPersonalCenterInfo() {
      personalCenterInfoApi({from:'ylyx'}).then((res) => {
        const {
          accountBalance,
          encouragement,
          uleCardBalance,
          useableCouponCount,
        } = res;
        this.accountBalance = accountBalance;
        this.encouragement = encouragement;
        this.uleCardBalance = uleCardBalance;
        this.useableCouponCount = useableCouponCount;
      });
    },
    // 金额跳转
    handleMoney(type) {
      switch (type) {
        // 余额
        case "accountBalance":
          window.location.href = `//m.${this.$uleUrl()}/muser/wallet/accountBalance`;
          break;
        // 奖励金
        case "encouragement":
          window.location.href = `//www.${this.$uleUrl()}/yxd/event/incentives/#/`;
          break;
        // 邮乐卡
        case "uleCardBalance":
          window.location.href = `//m.${this.$uleUrl()}/muser/wallet/ulecard/list`;
          break;
        // 我的资产
        case "totalAssets":
          window.location.href = `//m.${this.$uleUrl()}/muser/wallet/totalAssets`;
          break;
      }
    },
    handleToAddr(){
      window.location.href = `//h5.${this.$uleUrl()}/yxd/mall/address/addresslist`;
    }
  },
};
